import { createContext } from 'react'

import { CYPRESS_OPTIONS, IS_CYPRESS } from 'src/utils/misc'

export const OrganizationContext = createContext({
    organizationId: IS_CYPRESS
        ? CYPRESS_OPTIONS.userOrganizationId
        : localStorage.getItem('userOrganizationId'),
    setOrganizationId: () => {},
})

OrganizationContext.displayName = 'OrganizationContext'

export default OrganizationContext
